module.exports = __webpack_public_path__ + "media/images/shared/logo_pc-e2586f9483785e1619f714c086ff9fa9.svg";